export default {
  strict: true,
  namespaced: true,
  state: {
    referrals: {
      list: [],
      isMax: false,
      currentPage: 0,
      perPage: 20,
      total: 0
    }
  },
  mutations: {
    resetReferrals (state) {
      state.referrals.list = []
    },
    addReferrals (state, value) {
      state.referrals.list.push(value)
    },
    resetTotalReferrals (state) {
      state.referrals.total = 0
    },
    setTotalReferrals (state, value) {
      state.referrals.total = value
    },
    setReferralsIsMax (state, value) {
      state.referrals.isMax = value
    },
    setReferralsCurrentPage (state, value) {
      state.referrals.currentPage = value
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/consumer/referrals.js